import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, InputLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React, { memo } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { NetworkManager } from "../../Components/NetworkManager";
import { CommonUtil } from "../../utils/CommonUtil";
import ToastManager from "../../Components/ToastManager";

const btnStyle = { marginTop: 10 };
function SetIGLiveDialog({
  setLiveOpen,
  onCancelDialogue,
  templateInfo,
  setSetLiveDialog,
}: any) {
  const initialValues = {
    checked:
      templateInfo.liveTemplateStatus !== null &&
      templateInfo.liveTemplateStatus !== undefined &&
      templateInfo.liveTemplateStatus === "active"
        ? true
        : false,
  };
  const validationSchema = Yup.object().shape({
    templateName: Yup.string()
      .min(3, "It's too short")
      .required("Please Enter Template Name"),
  });

  const [showDefaultField, setShowDefaultField] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [checkedDefault, setCheckedDefault] = useState(false);
  const [templateDetails, setTemplateDetails] = useState({
    templateId: "",
    templateName: "",
    templateStatus: "",
  });

  useEffect(() => {
    if (setLiveOpen) {
      setCheckedDefault(false);
    }
  }, [setLiveOpen]);
  const handleClose = () => {
    onCancelDialogue();
  };

  const onSuccessCallLive = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData.statusCode === "Insta0000") {
      ToastManager.showToast("Template is Successfully Set to Live", "Success");
    } else if (respData.statusCode === "Insta1027") {
      ToastManager.showToast(
        "Error Occured while setting the template to Non-live ",
        "Error"
      );
    }
    setSetLiveDialog(false);
  };
  const onSuccessCall = (data: any) => {
    var respData = CommonUtil.parseData(data);

    if (respData) {
      if (respData.statusCode === "Insta0000") {
        if (respData.liveTemplateStatus === "active") {
          setTemplateId(respData.liveTemplateId);
          setTemplateDetails({
            ...templateDetails,
            templateId: respData.liveTemplateId,
            templateName: respData.liveTemplateName,
            templateStatus: respData.liveTemplateStatus,
          });
          setShowDefaultField(true);
        }
      }
    }
  };

  const onErrorCall = (data: any) => {
    ToastManager.showToast(
      "Error Occured while setting the template to Non-live ",
      "Error"
    );
  };
  const onErrorCallDefault = (err: any) => {
    ToastManager.showToast(
      "Error Occured while setting the template to Live ",
      "Error"
    );
  };
  const onErrorCallReset = (err: any) => {
    ToastManager.showToast(
      "Error Occured while setting the template to Non-live ",
      "Error"
    );
  };

  const onLiveCheckClick = (event: any) => {
    const fbPageInfo: any = localStorage.getItem("fbPageDetail");
    const recFbPageInfp = JSON.parse(fbPageInfo)?.instagram;
    const isChecked = event.target.checked;
    if (isChecked) {
      const param = `instaId=${recFbPageInfp.instaId}`;

      try {
        NetworkManager.sendJsonRequest(
          "instagram/live/template/checkForActiveLiveTemplate",
          "",
          param,
          "GET",
          true,
          onSuccessCall,
          onErrorCallDefault
        );
      } catch (error) {}
    } else {
      setShowDefaultField(false);
      setTemplateId("");
    }
    if (isChecked) {
      setCheckedDefault(true);
    } else {
      setCheckedDefault(false);
    }
  };

  const onSuccessCallResetTemp = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      if (respData.statusCode === "Insta0000") {
        ToastManager.showToast(
          "Current template is set from Live to Non-live",
          "Success"
        );
      }
    }
  };
  const reSetLiveTemplate = (templateRow: any) => {
    const fbPageInfo: any = localStorage.getItem("fbPageDetail");
    const recFbPageInfp = JSON.parse(fbPageInfo)?.instagram;
    const params = `liveTemplateId=${templateId}&instaId=${
      recFbPageInfp.instaId
    }&setTemplateStatus=${
      templateDetails.templateStatus === "active" ? "inactive" : ""
    }`;
    try {
      NetworkManager.sendJsonRequest(
        "instagram/live/template/setLiveTemplateStatus",
        "",
        params,
        "POST",
        true,
        onSuccessCallResetTemp,
        onErrorCallReset
      );
    } catch (error: any) {
      ToastManager.showToast(
        "Error Occured while setting the template to Live ",
        "Error"
      );
    }
  };
  const onSubmit = (values: any, isDefault: any) => {
    const fbPageInfo: any = localStorage.getItem("fbPageDetail");
    const recFbPageInfp = JSON.parse(fbPageInfo)?.instagram;

    const params = `liveTemplateId=${templateInfo.templateId}&instaId=${
      recFbPageInfp.instaId
    }&setTemplateStatus=${
      templateInfo.templateType === "inactive" ? "active" : ""
    }`;

    try {
      NetworkManager.sendJsonRequest(
        "instagram/live/template/setLiveTemplateStatus",
        "",
        params,
        "POST",
        true,
        onSuccessCallLive,
        onErrorCall
      );
    } catch (err: any) {}
  };

  return (
    <div>
      <Dialog
        open={setLiveOpen}
        PaperProps={{
          sx: {
            width: "80%",
            maxHeight: 600,
          },
        }}>
        <DialogTitle>Template Selection</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>
            {(props) => (
              <Form noValidate>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 0.5,
                    mt: "2vh",
                    mb: "3vh",
                  }}>
                  <Field
                    as={Checkbox}
                    label="Default?"
                    type="checkbox"
                    name="checked"
                    onClick={onLiveCheckClick}
                  />
                  <InputLabel sx={{ mt: "1.5vh" }}>
                    Set Live Template
                  </InputLabel>
                </Box>

                {showDefaultField ? (
                  <div style={{ marginLeft: "12px" }}>
                    <InputLabel sx={{ mt: "1.5vh" }}>
                      {`There's already a Live Template "${templateDetails.templateName}" attached to the page.`}
                    </InputLabel>

                    <InputLabel>
                      Do you want to replace it with the current one?
                    </InputLabel>
                    <Button
                      type="button"
                      sx={{
                        marginBottom: "10px",
                        backgroundColor: "lightblue",
                        borderRadius: "30%",
                      }}
                      onClick={(row: any) => {
                        reSetLiveTemplate(row);
                        setShowDefaultField(false);
                      }}>
                      Yes
                    </Button>
                  </div>
                ) : (
                  ""
                )}
                <Button
                  onClick={({ value, isDefault }: any) =>
                    onSubmit(value, isDefault)
                  }
                  style={btnStyle}>
                  Save
                </Button>
                <Button style={btnStyle} onClick={handleClose}>
                  Cancel
                </Button>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
export default memo(SetIGLiveDialog);

//onClick={onSubmit}
